import NavBar from '@/components/Nav.vue';
import Redeem from '@/components/Redeem.vue';
import functions from '@/functions.js';

export default {
    name: 'WelfarePage',
    components: {
        NavBar,
        Redeem
    },
    data() {
        return {
            page: 1,
            more: true,
            loading: false,
            welfares: [],
            overdueWelfares: [],
            redeem: {},
            dateFormat: functions.dateFormat
        }
    },
    created() {
        this.getWelfareList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getWelfareList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('welfare', {params: {page: this.page}}).then(result => {
                    this.page++;
                    this.more = result.data.more;
                    let now = Date.parse(new Date());
                    result.data.welfares.forEach(welfare => {
                        let overdue = welfare.end_time ? Date.parse(new Date(welfare.end_time)) < now : false;
                        welfare.overdue = overdue
                        if (overdue || welfare.use_status) {
                            this.overdueWelfares.push(welfare);
                        } else {
                            this.welfares.push(welfare);
                        }
                    })
                }).finally(() => {
                    this.loading = false;
                    //if (this.more && this.page === 2) {
                    //    this.getWelfareList()
                    //}
                })
            }
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getWelfareList();
            }
        }
    }
}